export const siteInfo = {
  name: "爆料网上",
  shortName: "爆料网",
  domain: "www.baoliao-web.cn",
  tagline: "事件真相 · 始末追踪",
  slogan: "把零散的线索，整理成一条看得懂的时间线",
  description:
    "爆料网上专注于热点事件始末追踪与后续进展盘点，从事件发生、舆情发酵到回应反转，完整梳理关键节点，帮助读者一次看清全貌。",
  email: "tips@baoliao-web.cn",
  workingEmail: "hello@baoliao-web.cn",
  since: "2019",
};

export const categoryList = [
  {
    key: "society",
    name: "社会民生",
    icon: "ri-community-line",
    desc: "公共事务、社区治理与日常生活里被忽略的细节。",
  },
  {
    key: "consumer",
    name: "商业消费",
    icon: "ri-shopping-bag-3-line",
    desc: "预付费、退费、交付与售后争议的完整脉络。",
  },
  {
    key: "tech",
    name: "科技数码",
    icon: "ri-cpu-line",
    desc: "平台规则、数据合规与产品承诺的落地情况。",
  },
  {
    key: "safety",
    name: "公共安全",
    icon: "ri-shield-check-line",
    desc: "安全责任划分与整改措施是否真正落实。",
  },
  {
    key: "health",
    name: "环境健康",
    icon: "ri-leaf-line",
    desc: "食品、环境与健康相关事件的检测与说明。",
  },
  {
    key: "culture",
    name: "文娱观察",
    icon: "ri-movie-2-line",
    desc: "内容行业争议、版权与从业者权益话题。",
  },
];

export const statusMeta = {
  ongoing: { label: "持续追踪", tone: "primary" },
  progress: { label: "有进展", tone: "accent" },
  concluded: { label: "已有结论", tone: "secondary" },
};

export const statsList = [
  { value: "1,860", label: "累计追踪事件", suffix: "+" },
  { value: "12,400", label: "整理时间线节点", suffix: "+" },
  { value: "37", label: "覆盖行业领域", suffix: "" },
  { value: "96", label: "读者信息完整度评分", suffix: "%" },
];

export const principlesList = [
  {
    icon: "ri-file-list-3-line",
    title: "先时间线，后结论",
    desc: "每起事件先按时间顺序还原节点，再讨论对错，避免情绪跑在事实前面。",
  },
  {
    icon: "ri-link-m",
    title: "每一条进展都可回溯",
    desc: "关键节点标注来源与时间，方便读者自行核对，不做无出处的判断。",
  },
  {
    icon: "ri-refresh-line",
    title: "反转也要写清楚",
    desc: "当出现新证据推翻早前说法时，保留原记录并标注更正，而不是悄悄删除。",
  },
  {
    icon: "ri-user-voice-line",
    title: "给当事人说话的位置",
    desc: "在盘点中始终为各方回应留出篇幅，让读者看到完整对话。",
  },
];

export const teamQuotes = [
  {
    name: "林一舟",
    role: "长期读者 · 媒体从业",
    text: "追一条新闻最怕七零八落，这里把时间线摆出来，谁先说了什么、后来怎么改口，一眼就清楚。",
  },
  {
    name: "苏念",
    role: "读者 · 社区工作者",
    text: "小区加装电梯那件事我全程跟过，整理得比我自己记的还全，后续整改也补上了。",
  },
  {
    name: "陈默",
    role: "读者 · 消费者维权志愿者",
    text: "预付费闭店那类事件节点很多，这里按时间排开，退费进度到哪一步一目了然。",
  },
];

export const faqGroups = [
  {
    group: "使用与阅读",
    items: [
      {
        q: "爆料网上主要记录哪些类型的事件？",
        a: "以社会民生、商业消费、科技数码、公共安全、环境健康与文娱观察六大方向为主。我们优先选择“信息分散、读者需要自己拼凑”的事件，把它们整理成完整时间线。",
      },
      {
        q: "时间线里的节点是按什么顺序排列的？",
        a: "统一按事件发生的时间正序排列，节点上标明日期与进展类型。如果某条信息后来被更正，我们会在原节点旁标注更正说明，而不是直接删掉。",
      },
      {
        q: "没有账号可以阅读吗？",
        a: "可以。全站内容无需注册即可阅读，包含时间线、关键问答与相关事件推荐。",
      },
    ],
  },
  {
    group: "内容与原则",
    items: [
      {
        q: "你们会直接下判断说谁对谁错吗？",
        a: "我们更倾向于呈现各方说法、回应与可核对的节点。只有在已有明确结论（例如官方通报、有效判决）时，才会标注“已有结论”状态并说明依据。",
      },
      {
        q: "如何保证整理出来的内容不是单一来源？",
        a: "关键节点尽量交叉比对多方公开信息，并在节点描述中说明该进展来自哪一方的表态，避免只采信一种说法。",
      },
      {
        q: "事件还在发展时会更新吗？",
        a: "会。状态为“持续追踪”的事件会随新进展补充节点，并在列表页显示最近更新时间。",
      },
    ],
  },
  {
    group: "线索与联系",
    items: [
      {
        q: "我提供的线索会被怎么使用？",
        a: "我们仅用于核实事件节点与补充背景，不会公开你的个人联系方式。若线索暂不具备核实条件，我们会先存档并回复说明。",
      },
      {
        q: "多久能收到回复？",
        a: "工作日内一般两到三天会给出初步回复。涉及需要多方核实的线索，回复时间会稍长，我们会同步进度。",
      },
      {
        q: "可以要求更正或删除已发布内容吗？",
        a: "可以。请通过站点邮箱说明具体节点与理由，我们会在核实后补充更正说明；确有错误的表述我们会及时修订。",
      },
    ],
  },
];

export const milestones = [
  { year: "2019", title: "从一条时间线开始", desc: "最初只是编辑团队内部整理热点事件的手记，第一条时间线被读者自发转发。" },
  { year: "2021", title: "建立分类体系", desc: "把零散记录归入六大方向，开始区分“持续追踪 / 有进展 / 已有结论”三种状态。" },
  { year: "2023", title: "开放线索通道", desc: "读者可以提交亲历细节，编辑核实后补充进时间线，节点来源更立体。" },
  { year: "2026", title: "时间线模板标准化", desc: "统一节点字段与更正规则，让不同事件的整理方式保持一致、便于对照阅读。" },
];

export const hotTopics = [
  { label: "加装电梯费用分摊", count: "328 条进展" },
  { label: "预付费门店闭店退费", count: "512 条进展" },
  { label: "外卖超时扣款规则", count: "274 条进展" },
  { label: "新能源交付延期", count: "196 条进展" },
  { label: "景区停车收费争议", count: "158 条进展" },
  { label: "直播带货退货难", count: "241 条进展" },
];